/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Releases_Viewcreations1Inputs */

const id_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Kreasi`)
};

const ms_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Ciptaan`)
};

const da_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Oprettelser`)
};

const de_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreationen ansehen`)
};

const en_us2_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Creations`)
};

const es_es2_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver creaciones`)
};

const es_mx2_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver creaciones`)
};

const fil_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang mga Creation`)
};

const fr_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les créations`)
};

const it_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi creazioni`)
};

const hu_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozások megtekintése`)
};

const nl_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creaties bekijken`)
};

const no_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vis opprettelser`)
};

const pl_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz twory`)
};

const pt_br2_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver criações`)
};

const pt_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver criações`)
};

const ro_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi creații`)
};

const fi_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä luonnit`)
};

const sv_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa skapelser`)
};

const vi_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem sáng tạo`)
};

const tr_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturmaları Görüntüle`)
};

const cs_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit vytvoření`)
};

const bg_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте създавания`)
};

const ru_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть релизы`)
};

const uk_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути створення`)
};

const ar_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الإنشاءات`)
};

const hi_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण देखें`)
};

const th_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูการสร้าง`)
};

const ja_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成を見る`)
};

const zh_cn2_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看创作`)
};

const zh_hant1_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視創作`)
};

const ko_stats_releases_viewcreations1 = /** @type {(inputs: Stats_Releases_Viewcreations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 보기`)
};

/**
* | output |
* | --- |
* | "View Creations" |
*
* @param {Stats_Releases_Viewcreations1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_releases_viewcreations1 = /** @type {((inputs?: Stats_Releases_Viewcreations1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Releases_Viewcreations1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_releases_viewcreations1(inputs)
	if (locale === "ms") return ms_stats_releases_viewcreations1(inputs)
	if (locale === "da") return da_stats_releases_viewcreations1(inputs)
	if (locale === "de") return de_stats_releases_viewcreations1(inputs)
	if (locale === "en-US") return en_us2_stats_releases_viewcreations1(inputs)
	if (locale === "es-ES") return es_es2_stats_releases_viewcreations1(inputs)
	if (locale === "es-MX") return es_mx2_stats_releases_viewcreations1(inputs)
	if (locale === "fil") return fil_stats_releases_viewcreations1(inputs)
	if (locale === "fr") return fr_stats_releases_viewcreations1(inputs)
	if (locale === "it") return it_stats_releases_viewcreations1(inputs)
	if (locale === "hu") return hu_stats_releases_viewcreations1(inputs)
	if (locale === "nl") return nl_stats_releases_viewcreations1(inputs)
	if (locale === "no") return no_stats_releases_viewcreations1(inputs)
	if (locale === "pl") return pl_stats_releases_viewcreations1(inputs)
	if (locale === "pt-BR") return pt_br2_stats_releases_viewcreations1(inputs)
	if (locale === "pt") return pt_stats_releases_viewcreations1(inputs)
	if (locale === "ro") return ro_stats_releases_viewcreations1(inputs)
	if (locale === "fi") return fi_stats_releases_viewcreations1(inputs)
	if (locale === "sv") return sv_stats_releases_viewcreations1(inputs)
	if (locale === "vi") return vi_stats_releases_viewcreations1(inputs)
	if (locale === "tr") return tr_stats_releases_viewcreations1(inputs)
	if (locale === "cs") return cs_stats_releases_viewcreations1(inputs)
	if (locale === "bg") return bg_stats_releases_viewcreations1(inputs)
	if (locale === "ru") return ru_stats_releases_viewcreations1(inputs)
	if (locale === "uk") return uk_stats_releases_viewcreations1(inputs)
	if (locale === "ar") return ar_stats_releases_viewcreations1(inputs)
	if (locale === "hi") return hi_stats_releases_viewcreations1(inputs)
	if (locale === "th") return th_stats_releases_viewcreations1(inputs)
	if (locale === "ja") return ja_stats_releases_viewcreations1(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_releases_viewcreations1(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_releases_viewcreations1(inputs)
	return ko_stats_releases_viewcreations1(inputs)
});
export { stats_releases_viewcreations1 as "stats.releases.viewCreations" }